/**
 * ArtCredit: says plainly how the paintings were made. Shown only once there is
 * a painting in the build; the vector ornament was drawn for the app and needs
 * no credit.
 */
import React from 'react';
import { hasPaintedArt } from './artFiles';
import { ART_CREDIT } from '../../data/artwork';

const ArtCredit = ({ className }) => {
  if (!hasPaintedArt) return null;
  return <p className={className}>{ART_CREDIT}</p>;
};

export default ArtCredit;
